import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './PriceSummary.less';

class PriceSummary extends Component {
    static propTypes = {
        priceSummary: PropTypes.shape({
            /** Price, already formatted for a locale  */
            formattedAmount: PropTypes.string.isRequired,
            /** String describing the period of the price (per night, avg/night, total, etc) */
            pricePeriodDescription: PropTypes.string.isRequired,
            /** EDAP event payload fully describing the 'price.summary.display' event for this priceSummary */
            edapEventJson: PropTypes.string.isRequired
        })
    };

    render() {
        const {priceSummary} = this.props;

        if (priceSummary) {
            const {formattedAmount, pricePeriodDescription} = priceSummary;
            return (
                <span className="PriceSummary">
                    <strong className="PriceSummary__amount">
                        {formattedAmount}
                    </strong>
                    <span className="PriceSummary__period">
                        {pricePeriodDescription}
                    </span>
                </span>
            );
        }

        return null;
    }
}

export default PriceSummary;
